import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setActiveWorkspaceHeader } from "@/lib/quotationApi";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sid) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setActiveWorkspaceHeader(r.data?.user?.active_workspace_id || null);
        await refresh();
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth session exchange failed:", e);
        setErr("Sign-in failed. Please try again.");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-white/60 gap-4"
      data-testid="auth-callback"
    >
      {err ? (
        <>
          <p className="text-red-400">{err}</p>
          <a href="/" className="text-[#C5A880] underline text-sm">
            Back to home
          </a>
        </>
      ) : (
        <>
          <div className="w-8 h-8 border-2 border-[#C5A880] border-t-transparent rounded-full animate-spin" />
          <p>Signing you in…</p>
        </>
      )}
    </div>
  );
}
